import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

/*
 * This action is temporary and should only be used
 * with the sea-zinq-3sctr custom control flight
 */
const setLatestRenderedQFTraceId = action(
    'setLatestRenderedQFTraceId',
    (latestRenderedQFTraceId: string, scenarioId: SearchScenarioId) => ({
        latestRenderedQFTraceId,
        scenarioId,
    })
);

export default setLatestRenderedQFTraceId;
